// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__12M1M","footer":"ChangeClinic_footer__2qsnU"};